import { render, staticRenderFns } from "./CustomerNotifications.vue?vue&type=template&id=33176d55&scoped=true"
import script from "./CustomerNotifications.vue?vue&type=script&lang=js"
export * from "./CustomerNotifications.vue?vue&type=script&lang=js"
import style0 from "./CustomerNotifications.vue?vue&type=style&index=0&id=33176d55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33176d55",
  null
  
)

export default component.exports